import type { PaletteMode } from '@mui/material';
import { useState } from 'react';
import { readThemeHint, resolveThemeHint } from 'themes/themeHint';
import useSystemColorScheme from './useSystemColorScheme';

// For screens that render before the store: the last saved appearance, else the system setting.
const useStartupThemeMode = (): PaletteMode => {
  const [savedHint] = useState(readThemeHint);
  const systemColorScheme = useSystemColorScheme();
  return resolveThemeHint(savedHint ?? 'system', systemColorScheme);
};

export default useStartupThemeMode;
